import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../lib/lang-context";
import {
  Buildings,
  Bank,
  Stethoscope,
  Storefront,
  Tooth,
  TestTube,
} from "@phosphor-icons/react";

const ICONS = { Buildings, Bank, Stethoscope, Storefront, Tooth, TestTube };

export default function Sectors() {
  const { t } = useLang();
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="py-24 md:py-32 bg-slate-50 dark:bg-zinc-900 border-t border-slate-200 dark:border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
              {t.sectors.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tighter mt-5 text-[var(--icor-navy)] dark:text-white text-balance">
              {t.sectors.title}
            </h2>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.sectors.items.map((item, i) => {
            const Icon = ICONS[item.icon] || Buildings;
            return (
              <Reveal
                key={i}
                delay={i * 100}
                data-testid={`sector-card-${i}`}
                className="card-lift bg-white dark:bg-zinc-950 border border-slate-200 dark:border-zinc-800 p-7 group relative overflow-hidden h-full"
                style={{ borderRadius: 4 }}
              >
                <div className="flex items-start justify-between gap-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center"
                    style={{
                      background: "rgba(0,82,255,0.08)",
                      color: "var(--icor-blue)",
                      borderRadius: 4,
                    }}
                  >
                    <Icon size={24} weight="duotone" />
                  </div>
                  <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-slate-300 dark:text-zinc-700">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-[var(--icor-navy)] dark:text-white">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 dark:text-zinc-400 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-5 h-px w-10 bg-slate-200 dark:bg-zinc-700 group-hover:w-20 group-hover:bg-[var(--icor-blue)] transition-all duration-500" />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
